import { render, staticRenderFns } from "./MarketplaceProductList.vue?vue&type=template&id=fa1cd018&"
import script from "./MarketplaceProductList.vue?vue&type=script&lang=js&"
export * from "./MarketplaceProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports